/**
 * Created by jiachenpan on 16/11/18.
 */
import service from '@/utils/request.js';
import store from '@/store'
import Vue from 'vue'

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {Sting} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }
]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export const OPEN_STATUS = 1
export const REOPENED_STATUS = 2
export const RESOLVED_STATUS = 3
export const CLOSED_STATUS = 4
export const DUPLICATE_STATUS = 5
export const boolDisplay = {
  true: 'Ja',
  false: 'Nein'
}

export const modelTypes = [
  {id: 'question', text: 'GAP'},
  {id: 'task', text: 'Maßnahme'},
  {id: 'vt', text: 'VT'},
  {id: 'system', text: 'System'},
  {id: 'supplier', text: 'Dienstleister'},
  {id: 'tom', text: 'TOM'},
  {id: 'av', text: 'AV'},
  {id: 'vtverarbeiter', text: 'VTVerarbeiter'},
  {id: 'audit', text: 'Audit/Review'},
  {id: 'riskanalysis', text: 'Risikobewertung'},
]

export function originText(origin) {
  let originText = {}
  modelTypes.forEach(type => originText[type.id] = type.text)
  if (origin in originText) return originText[origin]
  return origin
}

export async function getDepartments(accountid, reset = true, callback = () => {}) {
  let departments = []
  service.request({
    url: `todos/v1/departments/${accountid}/`,
    method: 'GET',
    responseType: 'json'
  }).then(response => {
    response.data.forEach(item => departments.push({
      id: item.name,
      text: item.name
    }))
    if (store.getters.departments.length === 0 || reset) {
      store.commit('SET_DEPARTMENTS', departments)
    }
    callback()
  })
}

export async function getDataTypes(accountid, reset = true, callback = () => {}) {
  let dataTypes = []
  service.request({
    url: `todos/v1/datentype/${accountid}/`,
    method: 'GET',
    responseType: 'json'
  }).then(response => {
    response.data.forEach(item => dataTypes.push({
      id: item.name,
      text: item.name
    }))
    if (store.getters.dataTypes.length === 0 || reset) store.commit('SET_DATATYPES', dataTypes)
    callback()
  })
}

export async function getAllSupplierTypes(supplierTypes) {
  service.request({
    url: 'todos/v1/supplier_types/',
    method: 'GET',
    responseType: 'json'
  }).then(response => response.data.forEach(item => supplierTypes.push({
    id: item.id,
    text: item.text
  })))
}

export async function getSystems(accountid, reset= true, callback = () => {}) {
  let systems = []
  service.request({
    url: `todos/v1/system/${accountid}`,
    method: 'GET',
    responseType: 'json'
  }).then(response => {
    response.data.forEach(item => systems.push({
      id: item.name,
      text: item.name,
      value: item.id
    }))
    if (store.getters.systems.length === 0 || reset) store.commit('SET_SYSTEMS', systems)
    callback()
  })
}

export async function getSuppliers(accountid, reset= true, callback = () => {}) {
  let suppliers = []
  service.request({
    url: `todos/v1/suppliers/${accountid}/`,
    method: 'GET',
    responseType: 'json'
  }).then(response => {
    response.data.forEach(item => suppliers.push({
      id: item.name,
      text: item.name,
      value: item.id
    }))
    if (store.getters.suppliers.length === 0 || reset) store.commit('SET_SUPPLIERS', suppliers)
    callback()
  })
}

export async function fetchVTs(accountid) {
  if (store.getters.vts.length === 0) { // only fetch if not already fetched
    const response = await service.get(`todos/v1/vt/${accountid}/`)
    store.commit('SET_VTS', response.data)
  }
}

export async function getSystemWarnings(accountid, reset= true, callback = () => {}) {
  let systemWarnings = []
  service.request({
    url: `todos/v1/suppliers/?customer_id=${accountid}`,
    method: 'GET',
    responseType: 'json'
  }).then(response => {
    response.data.forEach(item => suppliers.push({
      id: item.name,
      text: item.name,
      value: item.id
    }))
    if (store.getters.suppliers.length === 0 || reset) store.commit('SET_SUPPLIERS', suppliers)
    callback()
  })
}

export async function getPersonGroups(accountid, reset= true, callback = () => {}) {
  let personGroups = []
    service.request({
    url: `todos/v1/persongroup/${accountid}`,
    method: 'GET',
    responseType: 'json'
  }).then(response => {
    response.data.forEach(item => personGroups.push({
      id: item.name,
      text: item.name
    }))
    if (store.getters.personGroups.length === 0 || reset) store.commit('SET_PERSONGROUPS', personGroups)
    callback()
  })
}

export async function getAbbreviations(reset= true, callback = () => {}) {
  let abbreviations = []
  service.request({
    url: `todos/v1/abbreviations/`,
    method: 'GET',
    responseType: 'json'
  }).then(response => {
    response.data.forEach(item => abbreviations.push({
      id: item.short,
      text: item.description,
      language: item.language,
    }))
    if (store.getters.abbreviations.length === 0 || reset) store.commit('SET_ABBREVIATIONS', abbreviations)
    callback()
  })
}

export function updateDepartments(departments, editor=null, field='departments') {
  const newDepartments = []
  departments.forEach(department => {
    if (!store.getters.departments.some(item => item.text === department)) {
      newDepartments.push({
        id: department,
        text: department
      })
    }
  })
  if (newDepartments.length > 0) {
    store.commit('SET_DEPARTMENTS', store.getters.departments.concat(newDepartments))
    if (editor != null) editor.field(field).update(store.getters.selectDepartmentOptions)
  }
}

export function updateSystems(system, editor=null, field='system') {
  if (!store.getters.systems.some(item => item.value === system.id)) {
    store.commit('SET_SYSTEMS', store.getters.systems.concat([{
      id: system.name,
      text: system.name,
      value: system.id
    }]))
    if (editor != null) editor.field(field).update(store.getters.selectSystemOptions)
  }
}

export function updateSuppliers(supplier, editor=null, field='supplier') {
  if (!store.getters.suppliers.some(item => item.value === supplier.id)) {
    store.commit('SET_SUPPLIERS', store.getters.suppliers.concat([{
      id: supplier.name,
      text: supplier.name,
      value: supplier.id
    }]))
    if (editor != null) editor.field(field).update(store.getters.selectSupplierOptions)
  }
}

export function updatePersonGroups(personGroups, editor=null, field='affected_person') {
  const newPersonGroups = []
  personGroups.forEach(personGroup => {
    if (!store.getters.personGroups.some(item => item.text === personGroup)) {
      newPersonGroups.push({
        id: personGroup,
        text: personGroup
      })
    }
  })
  if (newPersonGroups.length > 0) {
    store.commit('SET_PERSONGROUPS', store.getters.personGroups.concat(newPersonGroups))
    if (editor != null) editor.field(field).update(store.getters.selectPersonGroupsOptions)
  }
}

export function updateDataTypes(dataTypes, editor=null, field='data_type') {
  const newDataTypes = []
  dataTypes.forEach(dataType => {
    if (!store.getters.dataTypes.some(item => item.text === dataType)) {
      newDataTypes.push({
        id: dataType,
        text: dataType
      })
    }
  })
  if (newDataTypes.length > 0) {
    store.commit('SET_DATATYPES', store.getters.dataTypes.concat(newDataTypes))
    if (editor != null) editor.field(field).update(store.getters.selectDataTypeOptions)
  }
}

export function initSelect2() {
  if ($('.select').length > 0) {
    $('.select').each((index, item) => {
      let dropdownParent = $(document.body)
      if ($(item).parents('.modal').length != 0) {
        dropdownParent = $(item).parents('.modal')
      }
      if ($(item).hasClass('select-single')) {
        if ($(item).hasClass('allow-create')) {
          $(item).select2({
            width: '100%',
            dropdownParent: dropdownParent,
            tags: true,
            allowClear: true,
            placeholder: "--------",
          })
        } else {
          $(item).select2({
            width: '100%',
            dropdownParent: dropdownParent,
            allowClear: true,
            placeholder: "--------",
          })
        }
      } else {
        if ($(item).hasClass('allow-create')) {
          $(item).select2({
            width: '100%',
            dropdownParent: dropdownParent,
            multiple: true,
            closeOnSelect: true,
            tags: true,
          });
        } else {
          $(item).select2({
            width: '100%',
            dropdownParent: dropdownParent,
            multiple: true,
            closeOnSelect: false,
          });
        }
      }
    })
  }
}

export function noCacheURL(url) {
  if (url.includes('?')) return `${url}&cb=${Date.now()}`
  return `${url}?cb=${Date.now()}`
}

export function closeWarning(modalObject) {
  if (store.getters.modalDirty) {
    Vue.prototype.$confirm(
      {
        message: `Es wurden Änderungen vorgenommen, die noch nicht gespeichert sind. Möchten Sie dieses Fenster wirklich schließen?`,
        button: {
          no: 'Nein',
          yes: 'Ja'
        },
        callback: confirm => {
          if (confirm) {
            store.commit('SET_MODALDIRTY', false)
            $(modalObject).modal('hide')
          }
        }
      }
    )
  } else {
    $(modalObject).modal('hide')
  }
}

export function deleteAction(deleteCallback) {
  Vue.prototype.$confirm(
    {
      message: `Sind Sie sicher, diesen Eintrag zu löschen?`,
      button: {
        no: 'Nein',
        yes: 'Ja'
      },
      callback: confirm => {
        if (confirm) {
          deleteCallback()
        }
      }
    }
  )
}

export function ajaxErrorMessage(error) {
  let errMessage = error.toString()
  const dict2message = (dict) => {
    let message = ''
    Object.entries(dict).forEach(([key, value]) => {
      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        message += dict2message(value)
      } else {
        message += `${key}: ${value.join('; ')} \n`
      }
    })
    return message
  }
  if (error.response.status === 400) {
    errMessage = dict2message(error.response.data)
  }
  return errMessage
}

export function isURL(str) {
  // Regular expression for URL validation
  // ^: Asserts the start of the string.
  //   (?:\w+:)?: This part (?: ... )? is a non-capturing group that matches the protocol part of the URL, like http:// or https://. \w+ matches one or more word characters (letters, digits, or underscores), and : matches the colon. The ? makes this whole group optional.
  //     \/\/: Matches the two forward slashes (//) after the protocol.
  //   ([^\s\.]+\.\S{2}|localhost[\:?\d]*): This part captures the domain name. Let's break it down further:
  //     [^\s\.]+: Matches one or more characters that are not whitespace or a dot. This ensures that the domain name doesn't start with a dot or contain whitespace.
  //         \.: Matches the dot separating the domain name.
  //         \S{2}: Matches exactly two non-whitespace characters. This ensures that the domain name ends with a top-level domain like .com, .org, etc.
  //   |: The pipe character serves as an OR operator, allowing for an alternative match.
  //     localhost[\:?\d]*: Matches if the domain name is "localhost" followed by an optional port number. [\:?\d]* matches zero or more occurrences of a colon followed by digits (port number).
  // \S*: Matches zero or more non-whitespace characters after the domain name. This is to ensure that there are no trailing spaces or characters after the URL.
  //     $: Asserts the end of the string.
  const urlPattern = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
  return urlPattern.test(str);
}

export function removeHtmlTags(text) {
  if (text) {
    return text.replace(/<[^>]*>/g, '');
  } else {
    return ''
  }
}

export function formatDate(date, format) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day);
}

export async function summarizeMessages(messagesToSummarize, wordCount=null) {
  try {
    return await service.request({
      url: `/todos/v1/summarize_chat/`,
      method: 'POST',
      responseType: 'json',
      data: { messages: messagesToSummarize, wordCount },
    }).then(response => {
      return response.data
    })
  } catch (error) {
    console.error('Error during summarization request:', error);
    throw error;
  }
}
